export default __webpack_public_path__ + "static/media/amex.0519a123.svg";